import React      from 'react';

import { Button } from '../Buttons/Base';
import { Text }   from '../Text/Text';
import classNames from 'classnames';
import styles from './Dropdown.css';

type DropdownProps = {
    buttonText: string;
    className?: string;
    topOffset?: number;
};

export class DropdownBox extends React.PureComponent<DropdownProps> {
    static defaultProps = {
        topOffset: 10,
    };

    dropdownRef = React.createRef<any>();

    state = {
        isOpened: false,
    };

    componentDidMount() {
        document.addEventListener('click', this.handleClickOutList, false);
    }

    componentWillUnmount() {
        document.removeEventListener('click', this.handleClickOutList, false);
    }

    triggerDropdown = (event: any) => {
        this.setState({ isOpened: !this.state.isOpened });
    }

    handleClickOutList = (event) => {
        if (!this.state.isOpened) {
            return;
        }

        const dropdownNode = this.dropdownRef.current;

        // Clicked outside
        if (!dropdownNode.contains(event.target)) {
            event.stopPropagation();
            event.preventDefault();
            this.setState({ isOpened: false });
            return;
        }
    }

    listClicked = (e) => {
        this.setState({ isOpened: false });
    }

    render() {
        const { buttonText, className, topOffset } = this.props;
        const { isOpened } = this.state;

        return (
            <DropdownContainer className = {className} ref = {this.dropdownRef}>
                <DropdownButton onClick = {this.triggerDropdown} aria-expanded = {isOpened}>
                    <DropdownContent>
                        <Caption>{buttonText}</Caption>
                        <IconContainer flipped = {isOpened}>
                            <IconImg src = "/icons/dropdown-arrow.png" title = "Expand dropdown" alt = "More" />
                        </IconContainer>
                    </DropdownContent>
                </DropdownButton>

                <ListItemsContainer hidden = {!isOpened} onClick = {this.listClicked}>
                    {this.props.children}
                </ListItemsContainer>
            </DropdownContainer>
        );
    }
}

const DropdownContainer = React.forwardRef<HTMLDivElement, any>((props, ref) => (
    <div ref = {ref} className = {classNames(styles.container, props.className)}>
        {props.children}
    </div>
));

const DropdownButton = (props: any) => <Button className = {styles.button} {...props} />;

const DropdownContent = (props: any) => <div className = {styles.dropdownContent}>{props.children}</div>;

const ListItemsContainer = ({hidden, ...props}: any) => (
    <ul className = {classNames(styles.listItemContainer, { [styles.hidden]: hidden })} {...props}>
        {props.children}
    </ul>
);

const IconContainer = (props: { flipped: boolean, [key: string]: any }) => (
    <div className = {classNames(styles.iconContainer, { [styles.flipped]: !!props.flipped })}>
        {props.children}
    </div>
);

const IconImg = (props: any) => <img {...props} className = {styles.iconImg} />;

const Caption = (props: any) => <Text className = {styles.caption} {...props} />;
